import { Box, styled } from '@mui/material';
import { FC, PropsWithChildren, useEffect } from 'react';
import { useGetUserPermissions } from '../services/userManager';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { TrackerIconButton } from './TrackerButtonWrapper';
import { ButtonName } from '../constants';
import { Edit } from '@mui/icons-material';
import { useSetCurrentModal } from '../services/modalManager';
import { useGetDefaultStore, useGetStores } from '../services/storeManager';

const Container = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  borderRadius: 4,
  color: theme.palette.grey[600],
  display: 'flex',
  gap: 6,
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  maxWidth: '19vw',
  height: theme.spacing(5),
}));

const StyledTypography = styled(Box)(({ theme }) => ({
  ...theme.typography.h5,
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
}));

const TextContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  width: '100%',
}));

type StoreViewTextProps = { storeName: string };
const StoreViewText: FC<StoreViewTextProps & PropsWithChildren> = ({
  storeName,
  children,
}) => {
  return (
    <Container data-testid="store-selector">
      <TextContainer>
        <FmdGoodIcon />
        <StyledTypography>{storeName}</StyledTypography>
        {children}
      </TextContainer>
    </Container>
  );
};

type StoreViewProps = {};
const StoreView: FC<StoreViewProps> = () => {
  const stores = useGetStores();
  const defaultStore = useGetDefaultStore();
  const updateCurrentModal = useSetCurrentModal();
  const userPermissions = useGetUserPermissions();

  const openStoresModal = () => {
    updateCurrentModal('storeSelector');
  };
  const displayedStoreName = defaultStore.name ?? 'No store';

  useEffect(() => {
    sessionStorage.setItem('selfApplyStore', JSON.stringify(defaultStore));
  }, [defaultStore]);

  return (
    <>
      <StoreViewText storeName={displayedStoreName}>
        {userPermissions?.StoreSelect && stores && stores.length > 1 && (
          <TrackerIconButton
            buttonName={ButtonName.EditStore}
            size="small"
            onClick={openStoresModal}
          >
            <Edit color="inherit" fontSize="medium" />
          </TrackerIconButton>
        )}
      </StoreViewText>
    </>
  );
};

export { StoreView, StoreViewText };
